import React, { useState } from 'react';

const ImgWithFallback = ({
  src,
  extensions,
  withDefaultExtensions,
  fallback,
  ultimateFallback,
  alt,
  ...otherProps
}: {
  /** the image which should be displayed.
   * without 'extensions' or 'withDefaultExtensions',
   * 'src' is supposed to include its own extension */
  src: string;
  /** if 'extensions' given, component will try all extensions before using fallback */
  extensions?: string[];
  /** same as extensions but with 'jpg' and 'png'
   * if both given, 'withDefaultExtensions' is ignored */
  withDefaultExtensions?: boolean;
  /** the fallback source if src cannot be displayed */
  fallback: string;
  /** 'ultimateFallback' must be an asset img
   * if the fallback itself cannot be rendered, display this img */
  ultimateFallback?: string;
  alt: string;
  [key: string]: unknown;
}): JSX.Element => {
  const [extensionIndex, setExtensionIndex] = useState(0);
  let realExtensions: string[] | null = null;
  if (extensions) {
    realExtensions = extensions;
  } else if (withDefaultExtensions) {
    realExtensions = ['jpg', 'png'];
  }

  const handleError = () => {
    if (extensionIndex === -1) {
      setExtensionIndex(-99);
    } else if (realExtensions && extensionIndex < realExtensions.length - 1) {
      setExtensionIndex((prevState) => prevState + 1);
    } else {
      setExtensionIndex(-1);
    }
  };

  let img = src;
  if (extensionIndex === -99) {
    img = ultimateFallback || '';
  } else if (extensionIndex === -1) {
    img = fallback;
  } else if (realExtensions?.length) {
    img = `${src}.${realExtensions[extensionIndex]}`;
  }

  return <img src={img} alt={alt} onError={handleError} {...otherProps} />;
};

ImgWithFallback.defaultProps = {
  alt: 'image',
  withDefaultExtensions: false,
};

export default ImgWithFallback;
